import { Pencil, Trash2, ChevronLeft, ChevronRight, Inbox } from "lucide-react";
import { Button } from "../ui/button";
import { KondisiBadge } from "../KondisiBadge";
import { ItemCards } from "./ItemCards";

const Cell = ({ value }) => (
  <span className="line-clamp-2 whitespace-pre-line" title={value}>{value || <span className="text-muted-foreground">-</span>}</span>
);

const Pager = ({ page, pages, setPage }) => (
  <div className="flex items-center justify-between px-4 py-3 border-t text-sm">
    <span className="text-muted-foreground" data-testid="pagination-info">Halaman {page} dari {pages}</span>
    <div className="flex gap-2">
      <Button size="sm" variant="outline" className="h-9 w-10" disabled={page <= 1} onClick={() => setPage(page - 1)} data-testid="pagination-prev"><ChevronLeft className="h-4 w-4" /></Button>
      <Button size="sm" variant="outline" className="h-9 w-10" disabled={page >= pages} onClick={() => setPage(page + 1)} data-testid="pagination-next"><ChevronRight className="h-4 w-4" /></Button>
    </div>
  </div>
);

export const ItemsTable = ({ cat, rows, start, showPolda, onEdit, onDelete, page, pages, setPage, onAdd }) => {
  const fields = cat.list.map((k) => cat.fields.find((f) => f.key === k));
  if (!rows.length) {
    return (
      <div className="border bg-card grid-bg py-16 flex flex-col items-center text-center" data-testid="items-empty">
        <Inbox className="h-8 w-8 text-muted-foreground" />
        <p className="mt-3 font-medium">Belum ada data yang cocok</p>
        <p className="text-sm text-muted-foreground">Ubah filter pencarian atau tambahkan data baru.</p>
        <Button className="mt-4" size="sm" onClick={onAdd} data-testid="empty-add-button">Tambah Data</Button>
      </div>
    );
  }
  return (
    <div className="border bg-card">
      <div className="md:hidden">
        <ItemCards cat={cat} rows={rows} start={start} showPolda={showPolda} onEdit={onEdit} onDelete={onDelete} />
      </div>
      <div className="hidden md:block overflow-x-auto">
        <table className="w-full text-sm" data-testid="items-table">
          <thead>
            <tr className="text-left border-b bg-muted/60">
              <th className="px-4 py-2.5 eyebrow w-12">No</th>
              {showPolda && <th className="px-3 py-2.5 eyebrow">Polda</th>}
              {fields.map((f) => <th key={f.key} className="px-3 py-2.5 eyebrow whitespace-nowrap">{f.label}</th>)}
              <th className="px-4 py-2.5 eyebrow text-right">Aksi</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((it, i) => (
              <tr key={it.item_id} className="border-b last:border-0 hover:bg-muted/40 transition-colors align-top" data-testid={`item-row-${it.item_id}`}>
                <td className="px-4 py-2.5 font-mono text-muted-foreground">{start + i + 1}</td>
                {showPolda && <td className="px-3 py-2.5 font-medium whitespace-nowrap">{it.polda}</td>}
                {fields.map((f) => (
                  <td key={f.key} className="px-3 py-2.5 max-w-[260px]">
                    {f.key === "kondisi" ? <KondisiBadge kat={it.kondisi_kat} raw={it.data.kondisi} /> : <Cell value={it.data[f.key]} />}
                  </td>
                ))}
                <td className="px-4 py-2 text-right whitespace-nowrap">
                  <Button size="icon" variant="ghost" className="h-8 w-8" onClick={() => onEdit(it)} data-testid={`edit-item-${it.item_id}`} title="Lihat / Ubah"><Pencil className="h-4 w-4" /></Button>
                  <Button size="icon" variant="ghost" className="h-8 w-8 text-rose-600 hover:text-rose-700" onClick={() => onDelete(it)} data-testid={`delete-item-${it.item_id}`} title="Hapus"><Trash2 className="h-4 w-4" /></Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Pager page={page} pages={pages} setPage={setPage} />
    </div>
  );
};
